export default __webpack_public_path__ + "static/media/allnfts-light.e1f05b7e.svg";